/**
 * The words of the platform console's Acquisition learning tab (Acquisition P7): what a proposal sets the points to,
 * and what the pack needs, labelled. Pure.
 */
import type { LearningProposal } from "@/lib/api/acquisition-points";

/** The organisations a correction must be made at, as the console offers them (the server takes 2 to 1,000). */
export const MIN_ORGS_CHOICES = [2, 3, 5] as const;

/** The server's default, and the console's: a correction made at three organisations. */
export const DEFAULT_MIN_ORGS = 3;

/** The proposals the table lists before Show all. */
export const COLLAPSED_PROPOSALS = 50;

/** The line every reader of the tab is told: a proposal is a pattern, never a plant's own name. */
export const OWN_NAMES_WORDS = "Do not copy a plant's own names into the pack.";

/** The choice of the least organisations, in words. */
export function minOrgsWords(n: number): string {
  return `${n.toLocaleString("en-US")} organisations or more`;
}

/** What a proposal sets the points to, in words: the parameter's label with its name. */
export function targetWords(p: LearningProposal): string {
  return p.param_label && p.param_label !== p.param ? `${p.param_label} (${p.param})` : p.param;
}

/** The proposals the table lists: the first COLLAPSED_PROPOSALS, or all of them once the person asked. */
export function listedProposals(proposals: readonly LearningProposal[], showAll: boolean): LearningProposal[] {
  return showAll || proposals.length <= COLLAPSED_PROPOSALS ? [...proposals] : proposals.slice(0, COLLAPSED_PROPOSALS);
}

/** What the pack needs, as a label. */
export const NEED_LABELS: Record<LearningProposal["need"], string> = {
  alias: "New alias",
  none: "Already in the pack",
};
